import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { StockService } from '../../stock.service';
import { STOCK_TTL_ES } from '../../stock.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { IProductUnregulated } from 'src/app/pages/gestion/products-unregulated/product-unregulated.interface';
import { IRegulatedProduct } from 'src/app/pages/gestion/regulated-products/regulated-product.interface';
import { BranchStoreSelected } from 'src/app/pages/gestion/branch-stores/components/details/branch-store-details.component';
export type ITypeProduct = 'REGULATED' | 'UNREGULATED';
export type ITypeProductId = 1 | 2;
export const TYPE_PRODUCT = {
  REGULATED: 1,
  UNREGULATED: 2
};
@Component({
  selector: 'pg-stock-create',
  templateUrl: './stock-create.component.html'
})
export class StockCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  PRODUCTS_TYPES_NAMES_FOR_DROPDOWN = [
    { label: 'REGULADOS', value: 'REGULATED' },
    { label: 'NO REGULADOS', value: 'UNREGULATED' }
  ];
  branchStoreSelected = new BranchStoreSelected('Sucursal Destino');
  select = {
    product: {
      type: 'single',
      REGULATED: {
        openDialog: false,
        id: null
      },
      UNREGULATED: {
        openDialog: false,
        id: null
      },
      data: null
    }
  };

  constructor(private fb: FormBuilder, private stockService: StockService) {
    super(STOCK_TTL_ES, stockService);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      branchStoreSelected: [null, [Validators.required]],
      productType: [null, Validators.required],
      quantity: [null, [Validators.required, Validators.min(1)]],
      purchasePrice: [null, [Validators.required, Validators.min(1)]],
      product: [null, Validators.required],
      expAt: [null, Validators.required],
      lot: [null, [Validators.required]]
    });
  }

  onSelectedRegulatedProduct(row: IRegulatedProduct) {
    if (row) {
      this.select.product.data = row;
      this.fg.controls.product.setValue(`${row.code} - ${row.name}`);
      this.select.product.REGULATED.id = row.id;
    }
    this.select.product.REGULATED.openDialog = false;
  }

  onSelectedUnregulatedProduct(row: IProductUnregulated) {
    if (row) {
      this.select.product.data = row;
      this.fg.controls.product.setValue(`${row.code} - ${row.name}`);
      this.select.product.UNREGULATED.id = row.id;
    }
    this.select.product.UNREGULATED.openDialog = false;
  }

  openDialogByProductType() {
    this.select.product[this.fg.get('productType').value].openDialog = true;
  }

  onDropdownChanged() {
    this.fg.get('product').setValue(null);
  }

  async onSubmit() {
    const date = new Date(this.fg.get('expAt').value);
    const payload = {
      productId: this.select.product[this.fg.get('productType').value].id,
      typeProductId: TYPE_PRODUCT[this.fg.get('productType').value],
      branchStoreId: this.branchStoreSelected.getId(),
      lot: this.fg.get('lot').value,
      expAt: date.toISOString().split('T')[0],
      quantity: this.fg.get('quantity').value,
      purchasePrice: this.fg.get('purchasePrice').value,
      format: this.select.product.data.format,
      withIgv: true
    };
    this.message = { message: 'Registrando stock' };
    this.message = await this.stockService.register(payload);
    const status = this.message.status;
    if (status === 201) {
      setTimeout(() => {
        this.fg.reset();
        this.message = null;
      }, 1500);
    }
  }
}
